import React, { useEffect, useState } from 'react'
import PickupServiceImage from './Assets/PickupServiceImage.svg';
import pickupsteps from "./Assets/illustration.svg";
import { useNavigate } from "react-router-dom";
import { GetStudentPickupServiceOffers, UpdateStudentPickupServiceOffersStatus } from '../../Actions/CourseA';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import PickupServiceApproved from './PickupServiceApproved';
import PickupApprovedPopup from "./PickupApprovedPopup"

const NoPickupServiceIncluded = ({UserId, setPickupServiceOfferStatus, EnrollmentId,
     nextClass, studentAddress, nextClassId, userPickedStudentField, instituteAddress,
     institutePhoneNumber}) => {
    const navigate = useNavigate();
    const Dispatch = useDispatch()
    const [openPickupApprovePopup, setOpenPickupApprovePopup] = useState(false);


    const { enrolledStudentPickupServiceOffer } = useSelector((Store) => Store.CourseReducer);
    console.log("enrolledStudentPickupServiceOffer in PickupServiceComponentPage is:",enrolledStudentPickupServiceOffer)

    useEffect(() => {
        // Dispatching the action when the component mounts
        if(UserId){
            Dispatch(GetStudentPickupServiceOffers(UserId, EnrollmentId));
        }
    }, [Dispatch]); // Dependency array includes dispatch

    useEffect(() => {
        // Dispatching the action when the component mounts
        if(enrolledStudentPickupServiceOffer){
            setPickupServiceOfferStatus(enrolledStudentPickupServiceOffer.Status)
        }
    }, [Dispatch, enrolledStudentPickupServiceOffer]); // Dependency array includes dispatch


    const handleRedirect = () => {
        navigate("/student/inbox"); // Redirect to /inbox
      };

    // Ensure the object is not undefined before destructuring
    const { CreatedAt = "", Offers = 0, Message = "", Status="", ApprovedAt = "", } = enrolledStudentPickupServiceOffer || {};

    // Format date only if CreatedAt exists
    const formattedDate = CreatedAt ? moment(CreatedAt).format("MMM DD, YYYY") : "N/A";
    const hoursAgo = CreatedAt ? moment().diff(moment(CreatedAt), 'hours') : "N/A";

    // Format date only if CreatedAt exists
    const formattedApprovedDate = ApprovedAt ? moment(ApprovedAt).format("MMM DD, YYYY") : "N/A";
    const ApprovedhoursAgo = ApprovedAt ? moment().diff(moment(ApprovedAt), 'hours') : "N/A";

    let CreatedDisplayTime;
    if (hoursAgo === null) {
        CreatedDisplayTime = "N/A";
    } else if (hoursAgo < 24) {
        CreatedDisplayTime = `${hoursAgo} hours ago`;
    } else if (hoursAgo < 168) { // 7 days = 168 hours
        const daysAgo = Math.floor(hoursAgo / 24);
        CreatedDisplayTime = `${daysAgo} day${daysAgo > 1 ? 's' : ''} ago`;
    } else {
        const weeksAgo = Math.floor(hoursAgo / 168);
        CreatedDisplayTime = `${weeksAgo} week${weeksAgo > 1 ? 's' : ''} ago`;
    }

    const handleAction = (action) => {
        Dispatch(UpdateStudentPickupServiceOffersStatus(UserId,action,EnrollmentId))
        .then(() => {
           // Set a timeout to refresh the page after 5 seconds
           setTimeout(() => {
                window.location.reload();
           }, 5000);

        })
    };
    
    return (
        <>
            {Status==="Approved" ? (
                <PickupServiceApproved
                formattedDate={formattedDate}
                hoursAgo={hoursAgo}
                Offers={Offers}
                Message={Message}
                UserId={UserId}
                EnrollmentId={EnrollmentId}
                formattedApprovedDate={formattedApprovedDate}
                ApprovedhoursAgo={ApprovedhoursAgo}
                CreatedDisplayTime={CreatedDisplayTime}
                 />
            ) : (
            <div className='w-full'>
                <div className='flex flex-col justify-center items-center'>
                    <img src={PickupServiceImage} alt="pickup image" className='w-[300px] h-[300px] lg:w-[400px] lg:h-[400px] mt-[-10px]' />
                    <p className='font-bold text-[24px] lg:text-[28px] text-center w-[320px] lg:w-[500px] text-[#4C34AD] mt-[-20px]'>You have not purchased the package containing Pickup Service.</p>
                    <p className='text-[16px] lg:text-[18px] text-center w-[320px] lg:w-[600px] mt-[15px]'>
                        In order to get the pickup service, Contact with the driving school staff to provide you an offer for pickup service. Still You will be able to see the map once you share OTP with Instructor
                    </p>

                    {nextClass ? (
                        <>
                            <p className="text-[18px] text-center mt-[20px]">
                            Your next In-Vehicle class is on
                            </p>
                            <p className="text-[18px] text-center font-bold mt-[5px]">
                            {nextClass.startDate.toLocaleDateString()} |{" "}
                            {nextClass.startDate.toLocaleTimeString([], {
                                hour: "2-digit",
                                minute: "2-digit",
                            })}
                            </p>
                            <p className="text-[18px] text-center font-bold mt-[5px]">Class ID: {nextClassId}</p>
                            <p className="text-[18px] text-center font-bold mt-[5px]">
                            Pickup Zone
                            </p>
                            <p className="text-[18px] text-center font-bold mt-[5px]">
                            {instituteAddress}
                            </p>
                            <p className="text-[18px] text-center font-bold mt-[5px]">
                            Institute Phone Number
                            </p>
                            <p className="text-[18px] text-center font-bold mt-[5px]">
                            {institutePhoneNumber}
                            </p>
                        </>
                        ) : (
                        <p className="text-[18px] text-center mt-[20px]">
                            No upcoming classes found.
                        </p>
                        )}

                    <div className='flex justify-center items-center gap-[10px] lg:gap-[15px] mt-[30px]'>
                        <button className={`w-[150px] lg:w-[180px] h-[40px] text-[14px] lg:text-[16px] text-center rounded-[10px] bg-[#4C34AD] text-[#FFFFFF] font-bold`}
                        onClick={handleRedirect}
                        >
                            Chat with Staff
                        </button>

                        <button className={`w-[150px] lg:w-[180px] h-[40px] text-[14px] lg:text-[16px] text-center rounded-[10px] text-[#FFFFFF] font-bold ${
                                userPickedStudentField
                                    ? 'bg-[#4C34AD] cursor-pointer'
                                    : 'bg-[#D7DAE2] cursor-not-allowed'
                            }`}
                            disabled={!userPickedStudentField} // Disable if false or null
                            onClick={() => navigate(`/track-instructor-location/${EnrollmentId}`)}
                        >
                            Initiate Navigation
                        </button>
                    </div>

                    {enrolledStudentPickupServiceOffer && (
                        <div className="w-full flex justify-center items-center mt-[50px]">
                            <div className='w-[75%] flex flex-col px-[40px] py-[20px] shadow-[4px_5px_6px_#00000029] rounded-[10px]'
                            style={{
                                border:"1px solid #BCBCBC"
                            }}>
                                <p className='text-[24px] text-[#4C34AD] font-bold'>My Offers</p>
                                <div className='w-full flex justify-between mt-[30px]'>
                                    <div className='flex flex-col'>
                                        <p className='text-[20px] text-[#4C34AD] font-bold'>Date</p>
                                        <p className='text-[16px] text-[#4C34AD] mt-[15px]'>Initiated {formattedDate}</p>
                                        <p className='text-[14px] text-[#4C34AD] mt-[5px]'>{CreatedDisplayTime}</p>
                                    </div>

                                    <div className='flex flex-col'>
                                        <p className='text-[20px] text-[#4C34AD] font-bold'>Offer</p>
                                        <p className='text-[16px] text-[#4C34AD] mt-[15px]'>{Offers} $</p>
                                    </div>

                                    <div className='flex flex-col'>
                                        <p className='text-[20px] text-[#4C34AD] font-bold'>Message</p>
                                        <p className='text-[16px] text-[#4C34AD] mt-[15px] w-[350px]'>{Message}</p>
                                    </div>

                                    {Status==="Rejected" ? (
                                        <div className='flex flex-col mr-[80px]'>
                                            <p className='text-[20px] text-[#4C34AD] font-bold'>Status</p>
                                            <p className='text-[16px] text-[#4C34AD] mt-[15px]'>{Status}</p>
                                        </div>
                                    ) : (
                                        <div className='flex flex-col mt-[-10px] py-[10px] px-[15px] rounded-[8px]'
                                        style={{
                                            border:"1px solid #4C34AD"
                                        }}>
                                        <p className='text-[20px] text-center text-[#4C34AD] font-bold'>Action</p>
                                        <div className='flex justify-center items-center gap-[10px] lg:gap-[15px] mt-[15px]'>
                                            <button className='w-[100px] h-[40px] text-[14px] text-center text-[#4C34AD] rounded-[10px] font-bold cursor-pointer'
                                            style={{
                                                border: '1px solid #4C34AD'
                                            }}
                                            onClick={() => handleAction("Rejected")}>
                                                Reject
                                            </button>

                                            <button className={`w-[100px] h-[40px] text-[14px] text-center rounded-[10px] bg-[#4C34AD] text-[#FFFFFF] font-bold cursor-pointer`}
                                            // onClick={() => handleAction("Approved")}
                                            onClick={()=>setOpenPickupApprovePopup(true)}
                                            >
                                                Accept
                                            </button>
                                        </div>
                                    </div>
                                    )}
                                </div>

                                {openPickupApprovePopup && (
                                    <PickupApprovedPopup 
                                        setOpenPickupApprovePopup={setOpenPickupApprovePopup}
                                        Offers={Offers}
                                        handleAction={handleAction}
                                    />
                                )}

                                <div className='mt-[15px]' style={{borderBottom:"1px solid #BCBCBC"}}></div>

                            </div>
                        </div>
                    )}

                    <p className='font-bold text-[24px] lg:text-[28px] text-center w-[320px] lg:w-[500px] text-[#4C34AD] mt-[50px]'>How it Works?</p>

                    <div className="w-full flex justify-center items-center mt-[30px]">
                        <div className='w-[75%] flex flex-col lg:flex-row justify-between items-center'>
                            <div className="flex justify-center items-center">
                                <img src={pickupsteps} alt="pickup image" className='' />
                                <p className='text-[16px] lg:text-[18px] w-[200px] ml-[-5px]'>If you did not received any offer for pickup, you can ask Driving staff to send you an offer.</p>
                            </div>

                            <div className="flex justify-center items-center">
                                <img src={pickupsteps} alt="pickup image" className='' />
                                <p className='text-[16px] lg:text-[18px] w-[200px] ml-[-5px]'>You can Reject the offer if you think the offer is high and you can ask the staff to resend new offer.</p>
                            </div>

                            <div className="flex justify-center items-center">
                                <img src={pickupsteps} alt="pickup image" className='' />
                                <p className='text-[16px] lg:text-[18px] w-[200px] ml-[-5px]'>Once the offer is approved the pickup service will be activated further.</p>
                            </div>
                        </div>
                    </div>
            </div>
            </div>
            )}
        </>
    )
}


export default NoPickupServiceIncluded